module.exports = __webpack_public_path__ + "img/logo-dark.20a7ad82.png";